// source: marketplace-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.marketplace_api.GetAllDeploymentRequest', null, global);
goog.exportSymbol('proto.marketplace_api.GetAllDeploymentResponse', null, global);
goog.exportSymbol('proto.marketplace_api.SearchableDeployment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marketplace_api.GetAllDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marketplace_api.GetAllDeploymentRequest.repeatedFields_, null);
};
goog.inherits(proto.marketplace_api.GetAllDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marketplace_api.GetAllDeploymentRequest.displayName = 'proto.marketplace_api.GetAllDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marketplace_api.SearchableDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marketplace_api.SearchableDeployment.repeatedFields_, null);
};
goog.inherits(proto.marketplace_api.SearchableDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marketplace_api.SearchableDeployment.displayName = 'proto.marketplace_api.SearchableDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.marketplace_api.GetAllDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.marketplace_api.GetAllDeploymentResponse.repeatedFields_, null);
};
goog.inherits(proto.marketplace_api.GetAllDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.marketplace_api.GetAllDeploymentResponse.displayName = 'proto.marketplace_api.GetAllDeploymentResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marketplace_api.GetAllDeploymentRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.marketplace_api.GetAllDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marketplace_api.GetAllDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.GetAllDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marketplace_api.GetAllDeploymentRequest}
 */
proto.marketplace_api.GetAllDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marketplace_api.GetAllDeploymentRequest;
  return proto.marketplace_api.GetAllDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marketplace_api.GetAllDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marketplace_api.GetAllDeploymentRequest}
 */
proto.marketplace_api.GetAllDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marketplace_api.GetAllDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marketplace_api.GetAllDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.GetAllDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.marketplace_api.GetAllDeploymentRequest} returns this
*/
proto.marketplace_api.GetAllDeploymentRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.GetAllDeploymentRequest} returns this
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.marketplace_api.GetAllDeploymentRequest} returns this
*/
proto.marketplace_api.GetAllDeploymentRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marketplace_api.GetAllDeploymentRequest} returns this
 */
proto.marketplace_api.GetAllDeploymentRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marketplace_api.SearchableDeployment.repeatedFields_ = [14,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marketplace_api.SearchableDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.marketplace_api.SearchableDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marketplace_api.SearchableDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.SearchableDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    visibility: jspb.Message.getFieldWithDefault(msg, 3, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, ""),
    projectid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    organizationid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tagList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    language: jspb.Message.getFieldWithDefault(msg, 16, ""),
    organization: (f = msg.getOrganization()) && common_pb.Organization.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 18, ""),
    description: jspb.Message.getFieldWithDefault(msg, 19, ""),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    appappearance: (f = msg.getAppappearance()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    webappearance: (f = msg.getWebappearance()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    modelproviderid: jspb.Message.getFieldWithDefault(msg, 26, "0"),
    modelprovidername: jspb.Message.getFieldWithDefault(msg, 27, ""),
    modeloptionsList: jspb.Message.toObjectList(msg.getModeloptionsList(),
    common_pb.Metadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marketplace_api.SearchableDeployment}
 */
proto.marketplace_api.SearchableDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marketplace_api.SearchableDeployment;
  return proto.marketplace_api.SearchableDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marketplace_api.SearchableDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marketplace_api.SearchableDeployment}
 */
proto.marketplace_api.SearchableDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibility(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationid(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addTag(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 17:
      var value = new common_pb.Organization;
      reader.readMessage(value,common_pb.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 24:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setAppappearance(value);
      break;
    case 25:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setWebappearance(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setModelproviderid(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelprovidername(value);
      break;
    case 12:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addModeloptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marketplace_api.SearchableDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marketplace_api.SearchableDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marketplace_api.SearchableDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.SearchableDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVisibility();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProjectid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrganizationid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTagList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.Organization.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAppappearance();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getWebappearance();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getModelproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      26,
      f
    );
  }
  f = message.getModelprovidername();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getModeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string visibility = 3;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getVisibility = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string projectId = 7;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string organizationId = 8;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated string tag = 14;
 * @return {!Array<string>}
 */
proto.marketplace_api.SearchableDeployment.prototype.getTagList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setTagList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.addTag = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearTagList = function() {
  return this.setTagList([]);
};


/**
 * optional string language = 16;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional Organization organization = 17;
 * @return {?proto.Organization}
 */
proto.marketplace_api.SearchableDeployment.prototype.getOrganization = function() {
  return /** @type{?proto.Organization} */ (
    jspb.Message.getWrapperField(this, common_pb.Organization, 17));
};


/**
 * @param {?proto.Organization|undefined} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.SearchableDeployment.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string name = 18;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string description = 19;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.marketplace_api.SearchableDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.SearchableDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.marketplace_api.SearchableDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.SearchableDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Struct appAppearance = 24;
 * @return {?proto.google.protobuf.Struct}
 */
proto.marketplace_api.SearchableDeployment.prototype.getAppappearance = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 24));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setAppappearance = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearAppappearance = function() {
  return this.setAppappearance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.SearchableDeployment.prototype.hasAppappearance = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Struct webAppearance = 25;
 * @return {?proto.google.protobuf.Struct}
 */
proto.marketplace_api.SearchableDeployment.prototype.getWebappearance = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 25));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setWebappearance = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearWebappearance = function() {
  return this.setWebappearance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.SearchableDeployment.prototype.hasWebappearance = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional uint64 modelProviderId = 26;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getModelproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, "0"));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setModelproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 26, value);
};


/**
 * optional string modelProviderName = 27;
 * @return {string}
 */
proto.marketplace_api.SearchableDeployment.prototype.getModelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.setModelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * repeated Metadata modelOptions = 12;
 * @return {!Array<!proto.Metadata>}
 */
proto.marketplace_api.SearchableDeployment.prototype.getModeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 12));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
*/
proto.marketplace_api.SearchableDeployment.prototype.setModeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.marketplace_api.SearchableDeployment.prototype.addModeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marketplace_api.SearchableDeployment} returns this
 */
proto.marketplace_api.SearchableDeployment.prototype.clearModeloptionsList = function() {
  return this.setModeloptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.marketplace_api.GetAllDeploymentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.marketplace_api.GetAllDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.marketplace_api.GetAllDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.GetAllDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.marketplace_api.SearchableDeployment.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.marketplace_api.GetAllDeploymentResponse}
 */
proto.marketplace_api.GetAllDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.marketplace_api.GetAllDeploymentResponse;
  return proto.marketplace_api.GetAllDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.marketplace_api.GetAllDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.marketplace_api.GetAllDeploymentResponse}
 */
proto.marketplace_api.GetAllDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.marketplace_api.SearchableDeployment;
      reader.readMessage(value,proto.marketplace_api.SearchableDeployment.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.marketplace_api.GetAllDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.marketplace_api.GetAllDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.marketplace_api.GetAllDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.marketplace_api.SearchableDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated SearchableDeployment data = 3;
 * @return {!Array<!proto.marketplace_api.SearchableDeployment>}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.marketplace_api.SearchableDeployment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.marketplace_api.SearchableDeployment, 3));
};


/**
 * @param {!Array<!proto.marketplace_api.SearchableDeployment>} value
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
*/
proto.marketplace_api.GetAllDeploymentResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.marketplace_api.SearchableDeployment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.marketplace_api.SearchableDeployment}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.marketplace_api.SearchableDeployment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
*/
proto.marketplace_api.GetAllDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
*/
proto.marketplace_api.GetAllDeploymentResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.marketplace_api.GetAllDeploymentResponse} returns this
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.marketplace_api.GetAllDeploymentResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.marketplace_api);
